var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Profil",
    transform: "translate(-986.000000, -2592.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 2167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(62.000000, 357.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(870.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(54.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.6568027,10.6108446 L14.0126156,12.7131455 L11.0156946,9.8165364 L13.7547319,7.16923859 L17.6568027,9.42136408 C17.8715934,9.54502884 18,9.76738758 18,10.0155098 C18,10.2640284 17.8715934,10.4863872 17.6568027,10.6108446",
    id: "path112",
    transform: "translate(14.507847, 9.941192) scale(-1, 1) rotate(-180.000000) translate(-14.507847, -9.941192) "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    id: "path114",
    transform: "translate(6.995089, 4.796568) scale(-1, 1) rotate(-180.000000) translate(-6.995089, -4.796568) ",
    points: "13.3943292 2.77611526 9.38399091 5.09046949 0.595847961 9.59313502 10.5219693 0 13.3943292 2.77611526"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    id: "path116",
    transform: "translate(6.938933, 15.273097) scale(-1, 1) rotate(-180.000000) translate(-6.938933, -15.273097) ",
    points: "0.741658261 10.5472804 9.39905559 15.315508 13.1362077 17.4721104 10.5219693 19.9989144 0.741658261 10.5472804"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "path118",
    transform: "translate(5.013904, 10.070208) scale(-1, 1) rotate(-180.000000) translate(-5.013904, -10.070208) ",
    points: "0.00935596266 19.7572804 0 0.383135021 10.027808 10.074964"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.1396b3c4af8895ca1d330b2ac1ff075f.svg";
export { ForwardRef as ReactComponent };